import { cloneDeep } from 'lodash';
import React, { useEffect, useState } from 'react'
import { Form, Tab, Tabs } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { updateProperties } from '../../slices/inspectorSlice';
import ScriptEditor from '../common/ScriptEditor';
import { BdaServiceProperty } from '../../models/BdaService';

type Props = {
  properties: BdaServiceProperty[];
}

export default function ServicePropertiesForm({ properties }: Props) {
  const dispatch = useDispatch();

  const [editingProperties, setEditingProperties] = useState(properties);

  useEffect(() => {
    setEditingProperties(properties);
  }, [properties]);

  const handlePropChange = (id: number, checkbox?: boolean, pure?: boolean) => (evt: any) => {
    const value = pure ? evt : checkbox ? evt.target.checked : evt.target.value;
    const index = editingProperties.findIndex(prop => prop.id === id);
    const newProperties = cloneDeep(editingProperties);
    newProperties[index].value = value;
    setEditingProperties(newProperties);
    if (checkbox) updateServiceProperties(null, newProperties);
  }

  const updateServiceProperties = (_evt?: any, newProperties?: BdaServiceProperty[]) => {
    dispatch(updateProperties(newProperties || editingProperties));
  }

  const tabs = editingProperties
    .filter(prop => !prop.invisible)
    .reduce((accumulator, current) => {
      const type = current.type;
      if (accumulator[type]) accumulator[type].push(current);
      else accumulator[type] = [current];
      return accumulator;
    }, {} as Record<string, BdaServiceProperty[]>);

  return (
    <Tabs defaultActiveKey="application">
      {Object.keys(tabs).sort().map(group => (
        <Tab key={group} title={group} eventKey={group}>
          <div className="p-2">
            {tabs[group]
              .sort((a, b) => {
                if (a.mandatory && !b.mandatory) return -1;
                else if (b.mandatory) return 0;
                else return 1;
              })
              .map((prop) => {
                if (prop.valueType === "JSON") return (
                  <Form.Group controlId={`${prop.key}-json-editor`} key={prop.key} className="mb-3">
                    <Form.Label>{prop.key} {prop.mandatory && '*'}</Form.Label>
                    <ScriptEditor
                      height="150px"
                      value={prop.value || prop.defaultValue || ""}
                      onChange={handlePropChange(prop.id!, false, true)}
                      onBlur={updateServiceProperties}
                    />
                    <Form.Text>{prop.description}</Form.Text>
                  </Form.Group>
                );

                if (prop.valueType === "BOOLEAN") {
                  const value = typeof prop.value === "boolean" ? prop.value : prop.value === "true";
                  const defaultChecked = typeof prop.defaultValue === "boolean" ? prop.defaultValue : prop.defaultValue === "true";
                  const checked = typeof prop.value === 'boolean' ? value : defaultChecked;

                  return (
                    <Form.Group key={prop.key} className="mb-3">
                      <Form.Check
                        type="checkbox"
                        label={prop.key}
                        id={`${prop.key}-checkbox`}
                        checked={checked}
                        onChange={handlePropChange(prop.id!, true)}
                        className="mb-0"
                      />
                      <Form.Text>{prop.description}</Form.Text>
                    </Form.Group>
                  )
                }

                return (
                  <Form.Group controlId={`${prop.key}-form-control`} key={prop.key} className="mb-3">
                    <Form.Label>{prop.key} {prop.mandatory && '*'}</Form.Label>
                    <Form.Control size="sm" type={prop.valueType === 'INT' ? 'number' : 'text'} placeholder={prop.defaultValue} value={prop.value || ""} onChange={handlePropChange(prop.id!)} onBlur={updateServiceProperties} />
                    <Form.Text>{prop.description}</Form.Text>
                  </Form.Group>
                );
              })}
          </div>
        </Tab>
      ))}
    </Tabs>
  )
}
